import React, { useState } from "react";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton, InputBase } from "@mui/material";
import "./styles.css";
import { sxIconButton, sxInputBase } from "./sxProps";
import { SearchProps } from "../../interfaces/props/SearchProps";

const Search: React.FC<SearchProps> = ({
  openLink,
  searchValue,
  setSearchValue,
}) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div
      className={`menu-login-pesquisa ${isFocused ? 'focused' : ''}`}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
    >
      <InputBase
        sx={sxInputBase}
        placeholder="Pesquisar"
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
      />
      <IconButton
        aria-label="Pesquisar"
        onClick={() => openLink("pesquisa", searchValue)}
        type="button"
        sx={sxIconButton}
      >
        <FontAwesomeIcon icon={faSearch} className="search-icon" />
      </IconButton>
    </div>
  );
};

export default Search;
